import { useEffect, useState } from 'react';
import { Modal } from '../../../Modal';
import { Input } from '../../../Inputs/Input';
import { Button } from '../../../Button';
import { formRules } from '../../FormRules';
import { FormProvider, useForm } from 'react-hook-form';
import { apiService } from '../../../../services/api';
import { useToast } from '../../../../hooks';
import { Level, SubjectEntity } from '../../../../services/api.types';
import { CheckboxesTags, Option } from '../../../Inputs/Checkboxes';
import { makeLevelLabel, translateSubjectLevel } from '../../../CalendarEvent';
type UpdateSubjectProps = {
  open: boolean;
  onClose: () => void;
  onUpdateSubject: (res: SubjectEntity) => void;
  subjectToUpdate: {
    id: number | string;
    label: string;
  };
};

const options = Object.values(Level).map((level) => ({
  id: level,
  label: translateSubjectLevel[level],
}));

const subjectDefaultValues = {
  subjectName: '',
  subjectLevels: [] as Option[],
};

export const UpdateSubject = ({
  open,
  onClose,
  onUpdateSubject,
  subjectToUpdate,
}: UpdateSubjectProps) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const forms = useForm({
    mode: 'all',
    defaultValues: subjectDefaultValues,
  });

  const onSubmit = async (data: typeof subjectDefaultValues) => {
    setIsLoading(true);
    await apiService
      .updateSubject(Number(subjectToUpdate.id), {
        name: data.subjectName,
      })
      .then((res) => {
        onUpdateSubject(res);
        toast.success(
          'Matéria atualizada: ' + makeLevelLabel[res.level](res.name)
        );
        setIsLoading(false);
        onClose();
      })
      .catch((error) => {
        toast.error('Erro ao cadastrar matéria');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!subjectToUpdate) return;
    const [name, level] = subjectToUpdate.label.split(' - ');
    const subjectToUpdate2: SubjectEntity = {
      id: Number(subjectToUpdate.id),
      name,
      level: level as Level,
    };
    forms.setValue('subjectName', subjectToUpdate2.name);
    forms.setValue('subjectLevels', [
      {
        id: subjectToUpdate2.id,
        label: subjectToUpdate2.level,
      },
    ]);
  }, [forms, subjectToUpdate]);

  return (
    <Modal open={open} onClose={onClose} className="w-full h-full">
      <FormProvider {...forms}>
        <form onSubmit={forms.handleSubmit(onSubmit)} className="p-4">
          <h3>Atualizar matéria</h3>
          <Input
            placeholder='Ex: "Matemática"'
            name="subjectName"
            label="Nome da Matéria"
            rules={formRules.subjectNameRequired}
          />
          <CheckboxesTags
            name="subjectLevels"
            label="Níveis"
            rules={formRules.levelRequired}
            options={options}
            disabled
          />
          <div className="flex gap-4 justify-end pt-4">
            <Button
              size="small"
              circular
              fullWidth={false}
              onClick={() => {
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              isLoading={isLoading}
              type="submit"
              size="small"
              circular
              fullWidth={false}
            >
              Atualizar
            </Button>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
